import React from "react";
import routes from "constants/routes";
import { IRouteConfig } from "components/route/RouteMap";


const ROUTES: IRouteConfig[] = [
  {
    path: routes.SIGN_IN,
    exact: true,
    component: React.lazy(() => import("./signin/SignInView")),
  },
  {
    path: routes.RESET_PASSWORD,
    exact: true,
    component: React.lazy(() => import("./reset/ResetPasswordView")),
  },
  {
    path: routes.REGISTER,
    exact: true,
    component: React.lazy(() => import("./register/RegisterView")),
  },
];

export default ROUTES;
